const gssp = (context) => {
  const { query: { edit } } = context;
  return { edit };
};

export default gssp;
